<template>
  <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.value)">
    <span>{{ organizationTypeString(params.value) }}</span>
  </vs-chip>
</template>

<script>
  export default {
    name: 'CellRendererStatus',
    computed: {
      chipColor() {
        return (value) => {
          if(value === "0") return "receive";
          if(value === "1") return "success";
          if(value === "2") return "danger";
          if(value === "3") return "warning";
          return "receive";
        }
      },
      organizationTypeString() {
        return (value) => {
          if (value == "0")  return this.$t('adminPackage.receive');
          if (value == "1")  return this.$t('adminPackage.textAgree');
          if (value == "2")  this.$t('adminPackage.textRefuse');
          if (value == "3")  this.$t('adminPackage.cancelled');
          return  this.$t('adminPackage.receive');
        }
      }
    }
  }
</script>

<style lang="scss" scpoped>
  .ag-grid-cell-chip {
    &.vs-chip-receive {
      background: rgba(#00CFDD,.15);
      color: rgba(#00CFDD,1) !important;
      font-weight: 500;
    }
    &.vs-chip-success {
      background: rgba(var(--vs-success),.15);
      color: rgba(var(--vs-success),1) !important;
      font-weight: 500;
    }
    &.vs-chip-warning {
      background: rgba(var(--vs-warning),.15);
      color: rgba(var(--vs-warning),1) !important;
      font-weight: 500;
    }
    &.vs-chip-danger {
      background: rgba(var(--vs-danger),.15);
      color: rgba(var(--vs-danger),1) !important;
      font-weight: 500;
    }
  }
</style>
